import type { ReactNode } from "react";

import { FEEDBACK_CATEGORIES } from "./feedbackTaxonomy";

export type FeedbackDateFilter = "all" | "7d" | "30d";

export const FeedbackFilters = ({
  category,
  metadata,
  notification,
  date,
  onCategory,
  onMetadata,
  onNotification,
  onDate,
}: {
  category: string;
  metadata: string;
  notification: string;
  date: FeedbackDateFilter;
  onCategory: (value: string) => void;
  onMetadata: (value: string) => void;
  onNotification: (value: string) => void;
  onDate: (value: FeedbackDateFilter) => void;
}) => (
  <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-4">
    <FeedbackFilterSelect
      label="Category"
      value={category}
      onChange={onCategory}
    >
      <option value="all">All categories</option>
      {FEEDBACK_CATEGORIES.map((item) => (
        <option key={item.id} value={item.id}>
          {item.label}
        </option>
      ))}
    </FeedbackFilterSelect>
    <FeedbackFilterSelect
      label="Metadata"
      value={metadata}
      onChange={onMetadata}
    >
      <option value="all">All metadata states</option>
      <option value="complete">Complete</option>
      <option value="partial">Partial</option>
      <option value="unavailable">Unavailable</option>
      <option value="unavailable_legacy">Legacy unavailable</option>
    </FeedbackFilterSelect>
    <FeedbackFilterSelect
      label="Slack"
      value={notification}
      onChange={onNotification}
    >
      <option value="all">All Slack states</option>
      <option value="sent">Sent</option>
      <option value="pending">Pending</option>
      <option value="failed">Failed</option>
    </FeedbackFilterSelect>
    <FeedbackFilterSelect
      label="Submitted"
      value={date}
      onChange={(value) => onDate(value as FeedbackDateFilter)}
    >
      <option value="all">All dates</option>
      <option value="7d">Last 7 days</option>
      <option value="30d">Last 30 days</option>
    </FeedbackFilterSelect>
  </div>
);

const FeedbackFilterSelect = ({
  label,
  value,
  onChange,
  children,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  children: ReactNode;
}) => (
  <label className="space-y-1 text-xs font-medium text-muted-foreground">
    <span>{label}</span>
    <select
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className="h-9 w-full rounded-md border bg-background px-3 text-sm font-normal text-foreground"
    >
      {children}
    </select>
  </label>
);
